import PropTypes from 'prop-types';
import React from 'react';
import {
  Box,
  Slide,
  Stack,
  Button,
  TextField,
  Typography,
  Divider,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as myLayananService from '../../../services/mylayanan';

RequestsRekomendasi.propTypes = {
  user: PropTypes.object.isRequired
};

export default function RequestsRekomendasi({ user }) {
  const navigate = useNavigate();
  const [nama, setNama] = React.useState('');
  const [tipePermohonan, setTipePermohonan] = React.useState('');
  const [kategoriPermohonan, setKategoriPermohonan] = React.useState('');

  const theme = useTheme();

  const createPermohonan = async () => {
    // if (2 !== 1)
    //   return toast.error(
    //     'Maaf, untuk sementara permohonan rekomendasi ditutup, terima kasih atas perhatiannya'
    //   );
    if (!user?.attributes?.id_instansi) return toast.error('ID Instansi tidak ditemukan');
    if (!user?.attributes?.id) return toast.error('ID User tidak ditemukan');
    if (!nama) return toast.error('Nama investasi tidak ditemukan');
    if (!tipePermohonan || !kategoriPermohonan)
      return toast.error('Jenis permohonan dan kategori permohonan harus dipilih');

    try {
      const body = {
        data: {
          type: 'rekomendasi',
          id: '1',
          attributes: {
            id_kategori_layanan: 'rekomendasi',
            id_instansi: user?.attributes?.id_instansi,
            requestor: user?.attributes?.id,
            status: 'draft',
            id_jenis_permohonan: 'rekomendasi'
          },
          meta: {
            rekomendasi: { name: nama },
            tipe_permohonan: tipePermohonan,
            kategori_permohonan: kategoriPermohonan
          }
        }
      };

      const result = await myLayananService.addLayanan(body);

      if (result) {
        toast.success('Draft Permohonan berhasil dibuat');
        navigate(
          `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
          {
            replace: true
          }
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <Slide direction="left" in="true" mountOnEnter unmountOnExit>
        <Box sx={{ flexDirection: 'column' }}>
          <Stack spacing={3} direction="column">
            <Box>
              <Stack direction="column" spacing={2}>
                <Box>
                  <Typography variant="body2">
                    Pelaksanaan rencana dan anggaran Sistem Pemerintahan Berbasis Elektronik oleh
                    Organisasi Perangkat Daerah di lingkungan Pemerintah Daerah Daerah Istimewa
                    Yogyakarta wajib disertai Rekomendasi TIK sebagaimana diamanatkan oleh Peraturan
                    Gubernur DIY Nomor 67 Tahun 2022 tentang Sistem Pemerintahan Berbasis Elektronik
                    Pemerintah Daerah Daerah Istimewa Yogyakarta. Rekomendasi diajukan oleh
                    Organisasi Perangkat Daerah kepada Dinas Komunikasi dan Informatika Daerah
                    Istimewa Yogyakarta.
                  </Typography>
                </Box>

                <Divider />

                <Box>
                  <FormControl>
                    <FormLabel id="permohonan-label">Jenis Permohonan</FormLabel>
                    <RadioGroup
                      aria-labelledby="permohonan-aria-label"
                      value={tipePermohonan}
                      name="permohonan-group"
                      onChange={(e) => setTipePermohonan(e.target.value)}
                    >
                      <FormControlLabel
                        value="new_rekomendasi"
                        control={<Radio />}
                        label="Permohonan rekomendasi baru"
                      />
                      {/* <FormControlLabel
                        value="archive"
                        control={<Radio />}
                        label="Pendataan rekomendasi lama/existing"
                      /> */}
                    </RadioGroup>
                  </FormControl>
                </Box>

                <Box>
                  <FormControl>
                    <FormLabel id="kategori-label">Kategori Permohonan</FormLabel>
                    <RadioGroup
                      aria-labelledby="kategori-aria-label"
                      value={kategoriPermohonan}
                      name="kategori-group"
                      onChange={(e) => setKategoriPermohonan(e.target.value)}
                    >
                      <FormControlLabel value="hardware" control={<Radio />} label="Hardware" />
                      <FormControlLabel value="software" control={<Radio />} label="Software" />
                    </RadioGroup>
                  </FormControl>
                </Box>

                <Stack direction="row">
                  <Box sx={{ flex: { xs: 12, sm: 6 } }}>
                    <TextField
                      value={nama}
                      onChange={(e) => setNama(e.target.value)}
                      fullWidth
                      label="Nama investasi/sistem elektronik"
                    />
                  </Box>
                  <Box sx={{ flex: { xs: 0, sm: 6 } }} />
                </Stack>

                <Box>
                  <Button
                    disabled={!nama || nama.length < 5 || !tipePermohonan || !kategoriPermohonan}
                    onClick={() => createPermohonan()}
                    variant="contained"
                  >
                    BUAT PERMOHONAN
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Slide>
    </>
  );
}
